const addTestsFromModal = (vueObj, testList) => {
  vueObj.jobDetail.interviewProcess.process[
    vueObj.selectedIPIndex
  ].selectedtests = testList;
  vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex].testID =
    testList.map((test) => test.testID);
  vueObj.ipValidations[vueObj.selectedIPIndex].selectedTestCount =
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
      .selectedtests.length === 0;
  vueObj.checkAutoTest();
};

const closeConfigModal = (objModal) => {
  objModal.sortByOrder = false;
  objModal.enableConfigFilter = false;
  objModal.filterColumnConfig = null;
  objModal.searchConfig = "";
  objModal.$bvModal.hide("viewconfigs");
};

const tagValidatorSkills = (vueObj, tag) => {
  if (tag.length > 128) {
    vueObj.skillsValidateMsg = "Skill should not exceed 128 characters";
    return false;
  }
  let skills = vueObj.jobDetail.skills.map((s) => s.toLowerCase());
  if (skills.includes(tag.toLowerCase())) {
    vueObj.skillsValidateMsg = "Duplicate skill";
    return false;
  } else return true;
};

const tagValidatorLoc = (vueObj, tag) => {
  if (tag.length > 128) {
    vueObj.locationValidateMsg = "Location should not exceed 128 characters";
    return false;
  }
  let location = vueObj.jobDetail.location.map((s) => s.toLowerCase());
  if (location.includes(tag.toLowerCase())) {
    vueObj.locationValidateMsg = "Duplicate location";
    return false;
  } else return true;
};

const checkSalary = (vueObj) => {
  if (vueObj.jobDetail.minSalary != "" && vueObj.jobDetail.maxSalary != "") {
    let min = parseFloat(vueObj.jobDetail.minSalary);
    let max = parseFloat(vueObj.jobDetail.maxSalary);
    if (!isNaN(min) && !isNaN(max)) {
      if (min <= max) {
        vueObj.salaryCheck = false;
      } else {
        vueObj.salaryCheck = true;
      }
    }
  } else {
    vueObj.salaryCheck = false;
  }
};

const checkDecimal = (vueObj) => {
  vueObj.$v.jobDetail.maxSalary.$model =
    vueObj.$v.jobDetail.maxSalary.$model.replace(/^0+(?=[1-9])/, "");
  vueObj.$v.jobDetail.minSalary.$model =
    vueObj.$v.jobDetail.minSalary.$model.replace(/^0+(?=[1-9])/, "");
  vueObj.decimalCheckMin = hasTwoDecimals(vueObj.jobDetail.minSalary);
  vueObj.decimalCheckMax = hasTwoDecimals(vueObj.jobDetail.maxSalary);
};

const hasTwoDecimals = (value) => {
  const parts = value.toString().split(".");
  return parts.length === 2 ? parts[1].length <= 2 : true;
};

const setOnClickListeners = (vueObj) => {
  const elem = document.getElementById("jobType");
  elem.addEventListener("click", () => {
    vueObj.showJobType = !vueObj.showJobType;
  });
  elem.addEventListener("keypress", () => {
    vueObj.showJobType = true;
  });
  elem.addEventListener("blur", () => {
    vueObj.showJobType = false;
  });

  const elem2 = document.getElementById("roleType");
  elem2.addEventListener("click", () => {
    vueObj.showRoles = !vueObj.showRoles;
  });
  elem2.addEventListener("keypress", () => {
    vueObj.showRoles = true;
  });
  elem2.addEventListener("blur", () => {
    vueObj.showRoles = false;
  });

  const elem3 = document.getElementById("expType");
  elem3.addEventListener("click", () => {
    vueObj.showExp = !vueObj.showExp;
  });
  elem3.addEventListener("keypress", () => {
    vueObj.showExp = true;
  });
  elem3.addEventListener("blur", () => {
    vueObj.showExp = false;
  });

  const elem4 = document.getElementById("eduType");
  elem4.addEventListener("click", () => {
    vueObj.showEdu = !vueObj.showEdu;
  });
  elem4.addEventListener("keypress", () => {
    vueObj.showEdu = true;
  });
  elem4.addEventListener("blur", () => {
    vueObj.showEdu = false;
  });

  const elem5 = document.getElementById("noticeType");
  elem5.addEventListener("click", () => {
    vueObj.showNotice = !vueObj.showNotice;
  });
  elem5.addEventListener("keypress", () => {
    vueObj.showNotice = true;
  });
  elem5.addEventListener("blur", () => {
    vueObj.showNotice = false;
  });
};

const getExperience = (vueObj) => {
  if (vueObj.jobDetail.experienceRequired === "others") {
    return "12+ years";
  } else if (vueObj.jobDetail.experienceRequired === "0-2") {
    return "Fresher(0-2 years)";
  } else if (vueObj.jobDetail.experienceRequired === "2-4") {
    return "Junior(2-4 years)";
  } else if (vueObj.jobDetail.experienceRequired === "4-6") {
    return "Senior(4-6 years)";
  } else if (vueObj.jobDetail.experienceRequired === "6-8") {
    return "Lead(6-8 years)";
  } else {
    return "Management(8-12 years)";
  }
};

const checkAllBasic = (vueObj) => {
  return (
    !vueObj.checkErrorBasic &&
    vueObj.jobDetail.title.length > 0 &&
    vueObj.jobDetail.jobType &&
    vueObj.jobDetail.jobType.length > 0 &&
    vueObj.jobDetail.role.length > 0 &&
    vueObj.jobDetail.description.length > 0 &&
    vueObj.jobDetail.experienceRequired.length > 0 &&
    vueObj.jobDetail.minSalary.length > 0 &&
    vueObj.jobDetail.maxSalary.length > 0 &&
    vueObj.jobDetail.educationQualification.length > 0 &&
    vueObj.jobDetail.noticePeriod.length > 0 &&
    vueObj.jobDetail.openingsCount &&
    vueObj.jobDetail.openingsCount.toString().length > 0 &&
    vueObj.jobDetail.skills.length > 0 &&
    vueObj.jobDetail.location.length > 0 &&
    (!vueObj.jobDetail.documents ||
      (vueObj.jobDetail.documents &&
        vueObj.jobDetail.requiredDocumets.length > 0))
  );
};

const checkAllData = (vueObj) => {
  let allFilled = true;
  vueObj.jobDetail.interviewProcess.process.forEach((process) => {
    if (vueObj.checkValidRound(process.id)) {
      if (process.type === "assesment") {
        allFilled = assessmentChecks(vueObj, process, allFilled);
      } else {
        if (process.startDate.length === 0) {
          allFilled = false;
        }
        if (process.endDate.length === 0) {
          allFilled = false;
        }
        if (process.duration.length === 0) {
          allFilled = false;
        }
      }
    }
  });
  return allFilled;
};
const assessmentChecks = (vueObj, process, allFilled) => {
  if (
    vueObj.ipValidations[process.id].passingPercentageLimit ||
    vueObj.passingPercentageData[process.id]?.length === 0
  ) {
    allFilled = false;
  }
  if (vueObj.ipTimeDiff) {
    allFilled = false;
  }
  if (process.selectedtests.length === 0) {
    allFilled = false;
  }
  if (process.configID === null) {
    allFilled = false;
  }
  if (process.openTestdt.length === 0) {
    allFilled = false;
  }
  if (process.closeTestdt.length === 0) {
    allFilled = false;
  }
  if (process.duration.length === 0) {
    allFilled = false;
  }
  if (!vueObj.ipValidations[process.id].autoCorrectCheck) {
    if (vueObj.selectedIPIndex === process.id) {
      if (vueObj.selectedEvaluators?.length === 0) {
        allFilled = false;
      }
    } else if (process.selevaluator.length === 0) {
      allFilled = false;
    }
  }
  return allFilled;
};
const checkSaveAndApprove = (vueObj, index) => {
  return (
    !vueObj.ipValidations[index].startDate &&
    !vueObj.ipValidations[index].endDate &&
    !vueObj.ipValidations[index].duration &&
    !vueObj.ipValidations[index].selectedTestCount &&
    !vueObj.ipValidations[index].selectedEvals &&
    !vueObj.ipValidations[index].passingPercentageLimit &&
    !vueObj.ipValidations[index].configID &&
    !vueObj.ipValidations[index].validStartDate &&
    !vueObj.ipValidations[index].validEndDate
  );
};
const checkIPRound = (vueObj, index, model, valid) => {
  handlePassing(vueObj, index, model, valid);
  handleIPRoundChecks(vueObj, index, model, valid);
  if (valid === "startDate" || valid === "endDate") {
    let process = vueObj.jobDetail.interviewProcess.process[index];
    if (process.type === "assesment") {
      if (process.openTestdt.length > 0 && process.closeTestdt.length > 0) {
        vueObj.validateDates(
          new Date(process.openTestdt),
          new Date(process.closeTestdt),
          index
        );
      }
    } else if (process.startDate.length > 0 && process.endDate.length > 0) {
      vueObj.validateDates(
        new Date(process.startDate),
        new Date(process.endDate),
        index
      );
    }
  }
  if (vueObj.jobDetail.interviewProcess.process[index].type === "assesment") {
    vueObj.ipValidations[index].saveAndApprove =
      !vueObj.checkSaveAndApprove(index);
  } else if (
    !vueObj.ipValidations[index].startDate &&
    !vueObj.ipValidations[index].endDate &&
    !vueObj.ipValidations[index].duration &&
    !vueObj.ipValidations[index].validStartDate &&
    !vueObj.ipValidations[index].validEndDate
  ) {
    vueObj.ipValidations[index].saveAndApprove = false;
  }
  vueObj.calculateCompute++;
  vueObj.$forceUpdate();
};
const handlePassing = (vueObj, index, model, valid) => {
  if (model !== "passing") {
    if (vueObj.jobDetail.interviewProcess.process[index][model].length > 0) {
      vueObj.ipValidations[index][valid] = false;
    }
  } else if (vueObj.passingPercentageData[vueObj.selectedIPIndex].length > 0) {
    vueObj.ipValidations[index][valid] = false;
  }
};
const handleIPRoundChecks = (vueObj, index, model, valid) => {
  if (model === "selevaluator") {
    if (vueObj.selectedEvaluators?.length > 0) {
      vueObj.ipValidations[index][valid] = false;
    }
  } else if (model === "duration") {
    if (vueObj.betweenCheckDuration || vueObj.invalidCharactersDuration) {
      vueObj.ipValidations[index].duration = true;
    }
  } else if (model === "passing") {
    if (vueObj.invalidCharactersPassing || vueObj.betweenCheckPassing) {
      vueObj.ipValidations[index].passingPercentageLimit = true;
    }
  }
};
const invalidCharactersPassing = (vueObj) => {
  for (let i = 33; i <= 47; i++) {
    let char = String.fromCharCode(i);
    if (
      vueObj.passingPercentageData?.[vueObj.selectedIPIndex]?.includes(char)
    ) {
      return true;
    }
  }
  for (let i = 58; i <= 126; i++) {
    let char = String.fromCharCode(i);
    if (
      vueObj.passingPercentageData?.[vueObj.selectedIPIndex]?.includes(char)
    ) {
      return true;
    }
  }
  return false;
};

const checkErrorBasic = (vueObj) => {
  return (
    vueObj.$v.jobDetail.title.$error ||
    vueObj.$v.jobDetail.jobType.$error ||
    vueObj.$v.jobDetail.role.$error ||
    vueObj.$v.jobDetail.description.$error ||
    vueObj.$v.jobDetail.experienceRequired.$error ||
    vueObj.$v.jobDetail.minSalary.$error ||
    vueObj.$v.jobDetail.maxSalary.$error ||
    vueObj.$v.jobDetail.educationQualification.$error ||
    vueObj.$v.jobDetail.noticePeriod.$error ||
    vueObj.$v.jobDetail.openingsCount.$error ||
    vueObj.$v.jobDetail.skills.$error ||
    vueObj.$v.jobDetail.location.$error ||
    vueObj.$v.jobDetail.requiredDocumets.$error ||
    vueObj.salaryCheck ||
    !vueObj.decimalCheckMin ||
    !vueObj.decimalCheckMax ||
    vueObj.dirtyCheckJobDesc
  );
};
const checkJDType = (vueObj) => {
  vueObj.$forceUpdate();
};
const betweenCheck = (vueObj, key) => {
  return (
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex][key]
      .length > 0 &&
    !vueObj.invalidCharactersCheck(key) &&
    (parseInt(
      vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex][key]
    ) < 5 ||
      parseInt(
        vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex][key]
      ) > 360)
  );
};

const invalidCharactersCheck = (vueObj, key) => {
  const value =
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex][
      key
    ].toString();

  for (let i = 0; i < value.length; i++) {
    let char = value[i];

    // Check if the current character is not a number
    if (!/^\d$/g.test(char)) {
      // Check if the current character is a minus sign
      if (char === "-") {
        // Check if the next character is a number
        if (i + 1 >= value.length || !/^\d$/g.test(value[i + 1])) {
          return true;
        }
      } else {
        return true;
      }
    }
  }

  return false;
};

const checkPanelRequired = (vueObj) => {
  if (vueObj.requiredPanel === "allpanelist") {
    vueObj.jobDetail.showAllPanelist = true;
    vueObj.jobDetail.assignedPanelist = [];
    vueObj.lenCheckPan = false;
  } else if (vueObj.requiredPanel === "partpanelist") {
    vueObj.jobDetail.showAllPanelist = false;
  } else {
    vueObj.jobDetail.showAllPanelist = false;
    vueObj.jobDetail.assignedPanelist = [];
    vueObj.lenCheckPan = false;
  }
};
const deleteTest = (vueObj, index) => {
  vueObj.jobDetail.interviewProcess.process[
    vueObj.selectedIPIndex
  ].selectedtests.splice(index, 1);
  vueObj.checkAutoTest();
  if (
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
      .selectedtests.length === 0
  ) {
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex].config =
      {};
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex].configID =
      null;
    vueObj.ipValidations[vueObj.selectedIPIndex].configID = false;
    vueObj.jobDetail.interviewProcess.process[
      vueObj.selectedIPIndex
    ].configName = "";
  }
  vueObj.$forceUpdate();
};

const onEvalScroll = (vueObj, e) => {
  // Get the target element of the scroll event.
  const { target } = e;

  // Check if the user has reached the bottom of the scrollable area.
  if (
    Math.ceil(target.scrollTop) + 1 >=
    target.scrollHeight - target.offsetHeight
  ) {
    // Check if there is more data to load.

    if (vueObj.checkbetween(vueObj.evalPageEnd, 0, vueObj.totalEval)) {
      vueObj.evalPage++;
      vueObj.getEvaluators();
    }
  }
};
const checkConfig = (vueObj) => {
  if (vueObj.typefunc === "add") {
    vueObj.addConfig();
  } else {
    vueObj.saveExistConfig();
  }
};
const goBack = (vueObj) => {
  vueObj.$router.push({
    name: "InternalHiringDashboard",
    params: {
      cardName: vueObj.$route.query.cardName,
      customerID: vueObj.$route.query.customerID,
    },
    query: {
      itype: vueObj.$route.query.itype,
      isort: vueObj.$route.query.isort,
      type: vueObj.$route.query.type,
      sort: vueObj.$route.query.sort,
    },
  });
};
const validateDates = (vueObj, ...args) => {
  if (args[0] < args[1]) {
    vueObj.ipValidations[args[2]].validStartDate = false;
    vueObj.ipValidations[args[2]].validEndDate = false;
    vueObj.ipValidations[args[2]].messageStart = "";
    vueObj.ipValidations[args[2]].messageEnd = "";
  } else if (args[0] > args[1]) {
    vueObj.ipValidations[args[2]].validEndDate = true;
    vueObj.ipValidations[args[2]].messageEnd =
      "End date can’t be earlier than start date";
  } else if (
    vueObj.jobDetail.interviewProcess.process[args[2]].type === "assesment"
  ) {
    vueObj.ipValidations[args[2]].validStartDate = true;
    vueObj.ipValidations[args[2]].validEndDate = true;
    vueObj.ipValidations[args[2]].messageStart =
      "Start date and end date cannot be same";
    vueObj.ipValidations[args[2]].messageEnd =
      "Start date and end date cannot be same";
  }
};
const openViewJdModal = (vueObj) => {
  if (
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
      .jdDetailsType === 1
  ) {
    vueObj.$bvModal.show("viewbasicjddetails");
  } else {
    vueObj.allDetailDropDowns = "openBasic";
    vueObj.$bvModal.show("viewalljddetails");
  }
};
const onVenScroll = (vueObj, e) => {
  // Get the target element of the scroll event.
  const { target } = e;
  // Check if the user has reached the bottom of the scrollable area.
  if (
    Math.ceil(target.scrollTop) + 1 >=
    target.scrollHeight - target.offsetHeight
  ) {
    // Check if there is more data to load.

    if (vueObj.checkbetween(vueObj.venPageEnd, 0, vueObj.totalVen)) {
      vueObj.venPage++;
      vueObj.getVendors();
    }
  }
};
const selectDosAndDonts = (vueObj, value, id) => {
  for (let i in vueObj.defaultdosanddonts) {
    if (value) {
      if (
        vueObj.testConfigData.config.dosAndDonts.length > 0 &&
        vueObj.testConfigData.config.dosAndDonts[0].value == ""
      ) {
        vueObj.testConfigData.config.dosAndDonts.splice(0, 1);
      }
      if (vueObj.defaultdosanddonts[i].value == id) {
        vueObj.testConfigData.config.dosAndDonts.push({
          value: "",
          code: "",
        });
        vueObj.testConfigData.config.dosAndDonts[
          vueObj.testConfigData.config.dosAndDonts.length - 1
        ].code = vueObj.defaultdosanddonts[i].value;
        vueObj.testConfigData.config.dosAndDonts[
          vueObj.testConfigData.config.dosAndDonts.length - 1
        ].value = vueObj.defaultdosanddonts[i].description;
      }
    } else {
      for (let j in vueObj.testConfigData.config.dosAndDonts) {
        if (vueObj.testConfigData.config.dosAndDonts[j].code == id) {
          vueObj.testConfigData.config.dosAndDonts.splice(j, 1);
        }
        if (vueObj.testConfigData.config.dosAndDonts.length == 0) {
          vueObj.testConfigData.config.dosAndDonts.push({
            value: "",
            code: "",
          });
        }
      }
    }
  }
};

const filterDocs = (vueObj) => {
  return vueObj.documentList.filter((data) => {
    return (
      vueObj.searchdoc.length == 0 ||
      data.text.toLowerCase().includes(vueObj.searchdoc.toLowerCase())
    );
  });
};
const openAddConfigModal = (vueObj) => {
  vueObj.typefunc = "add";
  vueObj.$v.testConfigData.$reset();
  vueObj.$v.configName.$reset();
  vueObj.testConfigData.config = {
    testOrg: "",
    testDesc: "",
    testInst: "",
    timebnsel: "",
    timebnvalue: "",
    dispDuration: false,
    dispCount: false,
    allowCandidateRemarks: false,
    quesPerScreen: "10",
    priority: "first",
    shuffle: false,
    dispReqStatus: false,
    displayReqFirst: false,
    dispMarks: false,
    test: "public",
    allowAgent: false,
    allowImageAndIdCapture: false,
    allowExtension: false,
    enableScreenShare: false,
    negativeMarkValue: null,
    openTestdt: (
      " " +
      vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
        .openTestdt
    ).slice(1),
    closeTestdt: (
      " " +
      vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
        .closeTestdt
    ).slice(1),
    passingPercentage:
      vueObj.passingPercentageData[vueObj.selectedIPIndex] === ""
        ? null
        : (" " + vueObj.passingPercentageData[vueObj.selectedIPIndex]).slice(1),
    testDuration:
      vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
        .duration === ""
        ? "30"
        : (
            " " +
            vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
              .duration
          ).slice(1),
    typingTest: false,
    enableProctoring: false,
    communicationTest: false,
    communicationTestDuration: 45,
    communicationTestAttempts: null,
    typingDuration: 60,
    includeTimeNotifics: false,
    enableCamera: false,
    includeEndTest: false,
    instantemail: false,
    internetCheck: false,
    maxnoattempts: 1,
    buffertime: null,
    timebetweenattempts: null,
    screenCapture: null,
    dosAndDonts: [
      {
        value: "",
        code: "",
      },
    ],
  };
  vueObj.testConfigData.configName = "";
  vueObj.configName = "";
  vueObj.$bvModal.show("modal-1");
};

const removeRecruiter = (vueObj, index) => {
  let folderID = vueObj.jobDetail.assignedTo[index].folderID;
  vueObj.jobDetail.assignedTo.splice(index, 1);
  let folderIndex = vueObj.jobDetail.userFolderIDs.Recruiters.findIndex(
    (folder) => folder == folderID
  );
  if (folderIndex != -1) {
    vueObj.jobDetail.userFolderIDs.Recruiters.splice(folderIndex, 1);
  }
  vueObj.lenCheckRec = vueObj.jobDetail.assignedTo.length === 0;
};
const removePanelist = (vueObj, index) => {
  let folderID = vueObj.jobDetail.assignedPanelist[index].folderID;
  vueObj.jobDetail.assignedPanelist.splice(index, 1);
  let folderIndex = vueObj.jobDetail.userFolderIDs.Panelist.findIndex(
    (folder) => folder == folderID
  );
  if (folderIndex != -1) {
    vueObj.jobDetail.userFolderIDs.Panelist.splice(folderIndex, 1);
  }
  vueObj.lenCheckPan =
    (vueObj.jobDetail.assignedPanelist.length == 0 &&
      vueObj.requiredPanel === "partpanelist") ||
    vueObj.requiredPanel === null;
};
const saveRecruiters = (vueObj) => {
  vueObj.jobDetail.assignedTo = [];
  vueObj.jobDetail.userFolderIDs.Recruiters = [];
  vueObj.selectedUsersList.forEach((user) =>
    vueObj.jobDetail.assignedTo.push(JSON.parse(user))
  );
  vueObj.selectedFoldersList.forEach((folder) =>
    vueObj.jobDetail.userFolderIDs.Recruiters.push(folder)
  );
  vueObj.$store.commit("folderVUEX/saveSelectedUsers", []);
  vueObj.$store.commit("folderVUEX/saveSelectedFolders", []);

  vueObj.showFolderModal = false;
  vueObj.lenCheckRec = vueObj.jobDetail.assignedTo.length == 0;
};
const savePanelists = (vueObj) => {
  vueObj.jobDetail.assignedPanelist = [];
  vueObj.jobDetail.userFolderIDs.Panelist = [];
  vueObj.selectedUsersList.forEach((user) =>
    vueObj.jobDetail.assignedPanelist.push(JSON.parse(user))
  );
  vueObj.selectedFoldersList.forEach((folder) =>
    vueObj.jobDetail.userFolderIDs.Panelist.push(folder)
  );
  vueObj.$store.commit("folderVUEX/saveSelectedUsers", []);
  vueObj.$store.commit("folderVUEX/saveSelectedFolders", []);
  vueObj.showFolderModal = false;
  vueObj.lenCheckPan =
    vueObj.jobDetail.assignedPanelist.length == 0 &&
    vueObj.requiredPanel === "partpanelist";
};
const fillConfigData = (vueObj, test) => {
  vueObj.testConfigData = test;
  vueObj.configName = test.configName;
  const defaultValues = {
    testOrg: "",
    testDesc: "",
    testInst: "",
    timebnsel: "",
    timebnvalue: "",
    dispDuration: false,
    dispCount: false,
    allowCandidateRemarks: false,
    quesPerScreen: "10",
    priority: "first",
    shuffle: false,
    dispReqStatus: false,
    displayReqFirst: false,
    dispMarks: false,
    test: "public",
    allowAgent: false,
    allowImageAndIdCapture: false,
    allowExtension: false,
    enableScreenShare: false,
    negativeMarkValue: null,
    openTestdt: null,
    closeTestdt: null,
    passingPercentage: null,
    testDuration: "30",
    typingTest: false,
    enableProctoring: false,
    communicationTest: false,
    communicationTestDuration: 45,
    communicationTestAttempts: null,
    typingDuration: 60,
    includeTimeNotifics: false,
    enableCamera: false,
    includeEndTest: false,
    instantemail: false,
    internetCheck: false,
    maxnoattempts: 1,
    buffertime: null,
    timebetweenattempts: null,
    screenCapture: null,
    dosAndDonts: [{ value: "", code: "" }],
  };
  vueObj.testConfigData.config = Object.keys(defaultValues).reduce(
    (acc, key) => {
      acc[key] = test.config?.[key] ?? defaultValues[key];
      return acc;
    },
    {}
  );
  handleIPChecks(vueObj, test);
};
const handleIPChecks = (vueObj, test) => {
  if (
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
      .configID !== null &&
    test.configID ===
      vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex].configID
  ) {
    vueObj.testConfigData.config.passingPercentage =
      vueObj.passingPercentageData[vueObj.selectedIPIndex];
    vueObj.testConfigData.config.openTestdt =
      vueObj.jobDetail.interviewProcess.process[
        vueObj.selectedIPIndex
      ].openTestdt;
    vueObj.testConfigData.config.closeTestdt =
      vueObj.jobDetail.interviewProcess.process[
        vueObj.selectedIPIndex
      ].closeTestdt;
    vueObj.testConfigData.config.testDuration =
      vueObj.jobDetail.interviewProcess.process[
        vueObj.selectedIPIndex
      ].duration;
  }
};
const viewConfig = (vueObj, test) => {
  vueObj.typefunc = "view";
  vueObj.fillConfigData(test);
  vueObj.$bvModal.show("modal-1");
};
const openFolderModal = (vueObj, flag) => {
  vueObj.$store.commit("folderVUEX/resetExpand");
  vueObj.$store.commit("folderVUEX/setModalType", flag);
  vueObj.$store.commit("folderVUEX/setActiveFolder", {});
  let userList = [];
  let folderList = [];
  if (flag === "Recruiter") {
    if (vueObj.jobDetail.assignedTo.length > 0) {
      vueObj.jobDetail.assignedTo.forEach((user) =>
        userList.push(vueObj.convertJSONtoString(user))
      );
    }
    if (vueObj.jobDetail.userFolderIDs.Recruiters.length > 0) {
      vueObj.jobDetail.userFolderIDs.Recruiters.forEach((folderIDs) =>
        folderList.push(folderIDs)
      );
    }
  } else if (flag === "Panelists") {
    if (vueObj.jobDetail.assignedPanelist.length > 0) {
      vueObj.jobDetail.assignedPanelist.forEach((user) =>
        userList.push(vueObj.convertJSONtoString(user))
      );
    }
    if (vueObj.jobDetail.userFolderIDs.Panelist.length > 0) {
      vueObj.jobDetail.userFolderIDs.Panelist.forEach((folderIDs) =>
        folderList.push(folderIDs)
      );
    }
  }
  vueObj.$store.commit("folderVUEX/saveSelectedUsers", userList);
  vueObj.$store.commit("folderVUEX/saveSelectedFolders", folderList);
  vueObj.showFolderModal = true;
};
const closeFolder = (vueObj) => {
  vueObj.$store.commit("folderVUEX/saveSelectedFolders", []);
  vueObj.$store.commit("folderVUEX/saveSelectedUsers", []);
  vueObj.$store.commit("folderVUEX/setActiveFolder", {});
  vueObj.$store.commit("folderVUEX/setActiveFolderID", "");
  vueObj.$store.commit("folderVUEX/setModalType", "");
  vueObj.showFolderModal = false;
};
const saveConfig = (vueObj, vueChild) => {
  if (
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
      .openTestdt === ""
  ) {
    vueObj.jobDetail.interviewProcess.process[
      vueObj.selectedIPIndex
    ].openTestdt = vueObj.tempConfig.config.openTestdt;
    vueObj.ipValidations[vueObj.selectedIPIndex].startDate = false;
  } else {
    vueObj.tempConfig.config.openTestdt =
      vueObj.jobDetail.interviewProcess.process[
        vueObj.selectedIPIndex
      ].openTestdt;
  }
  if (
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
      .closeTestdt === ""
  ) {
    vueObj.jobDetail.interviewProcess.process[
      vueObj.selectedIPIndex
    ].closeTestdt = vueObj.tempConfig.config.closeTestdt;
    vueObj.ipValidations[vueObj.selectedIPIndex].endDate = false;
  } else {
    vueObj.tempConfig.config.closeTestdt =
      vueObj.jobDetail.interviewProcess.process[
        vueObj.selectedIPIndex
      ].closeTestdt;
  }
  if (vueObj.passingPercentageData[vueObj.selectedIPIndex] === "") {
    vueObj.passingPercentageData[vueObj.selectedIPIndex] =
      vueObj.tempConfig.config.passingPercentage;
    vueObj.ipValidations[vueObj.selectedIPIndex].passingPercentageLimit = false;
  } else {
    vueObj.tempConfig.config.passingPercentage =
      vueObj.passingPercentageData[vueObj.selectedIPIndex];
  }
  if (
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
      .duration === ""
  ) {
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex].duration =
      vueObj.tempConfig.config.testDuration;
    vueObj.ipValidations[vueObj.selectedIPIndex].duration = false;
  } else {
    vueObj.tempConfig.config.testDuration =
      vueObj.jobDetail.interviewProcess.process[
        vueObj.selectedIPIndex
      ].duration;
  }
  vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex].config = {
    ...vueObj.tempConfig.config,
  };
  vueObj.ipValidations[vueObj.selectedIPIndex].configID = false;
  vueObj.jobDetail.interviewProcess.process[
    vueObj.selectedIPIndex
  ].config.typingDuration = 60;
  vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex].configName =
    vueObj.tempConfig.configName;
  vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex].configID =
    vueObj.tempConfig.configID;
  vueObj.ipValidations[vueObj.selectedIPIndex].saveAndApprove =
    !vueObj.checkSaveAndApprove(vueObj.selectedIPIndex);
  vueObj.calculateCompute++;
  vueObj.$bvModal.hide("confirm-config");
  vueObj.$bvModal.hide("expired-config");
  vueObj.$bvModal.hide("confirm-edit");
  if (vueChild) {
    vueChild.searchConfig = "";
  }
  vueObj.showConfigModal = false;
};

const gotopgnum = (vueObj, pagenum) => {
  vueObj.enableConfigFilter = false;
  vueObj.filterColumnConfig = "";
  vueObj.sortByOrder = false;
  vueObj.currentPage = pagenum;
};
const saveEvaluators = (vueObj, flag) => {
  vueObj.jobDetail.interviewProcess.process[
    vueObj.selectedIPIndex
  ].selevaluator = [];
  vueObj.selectedEvaluators.forEach((evals) =>
    vueObj.jobDetail.interviewProcess.process[
      vueObj.selectedIPIndex
    ].selevaluator.push(evals)
  );
  if (!flag) {
    vueObj.selectedEvaluators = [];
  }
};
const closeModal = (vueObj) => {
  vueObj.dirtyCheckQuestion = false;
  vueObj.$bvModal.hide("modal-1");
};
const fillAssessment = (vueObj, index, percent) => {
  vueObj.passingPercentageData[index] = percent;
  vueObj.ipValidations[index] = {
    passingPercentageLimit: false,
    selectedTestCount: false,
    selectedEvals: false,
    configID: false,
    startDate: false,
    endDate: false,
    duration: false,
    autoCorrectCheck: false,
    saveAndApprove: false,
    validStartDate: false,
    validEndDate: false,
    messageStart: "",
    messageEnd: "",
  };
};
const fillF2f = (vueObj, index) => {
  vueObj.passingPercentageData[index] = null;
  vueObj.ipValidations[index] = {
    startDate: false,
    endDate: false,
    duration: false,
    saveAndApprove: false,
    validStartDate: false,
    validEndDate: false,
    messageStart: "",
    messageEnd: "",
  };
};

const selectRound = (vueObj, id, flag) => {
  if (vueObj.selectedIPIndex != null) {
    vueObj.saveEvaluators();
  }
  vueObj.selectedIPIndex = id;
  if (flag) {
    vueObj.ipValidations = [];
    for (let i in vueObj.jobDetail.interviewProcess.process) {
      if (
        !vueObj.checkValidRound(vueObj.jobDetail.interviewProcess.process[i].id)
      ) {
        vueObj.ipValidations[i] = {};
        vueObj.passingPercentageData[i] = null;
      } else if (
        vueObj.jobDetail.interviewProcess.process[i].type === "assesment"
      ) {
        vueObj.jobDetail.interviewProcess.process[i].sentAutomatically = false;
        vueObj.jobDetail.interviewProcess.process[i].passingPercentage = "";
        vueObj.jobDetail.interviewProcess.process[i].selectedtests = [];
        vueObj.jobDetail.interviewProcess.process[i].config = {};
        vueObj.jobDetail.interviewProcess.process[i].selevaluator = [];
        vueObj.jobDetail.interviewProcess.process[i].configName = "";
        vueObj.jobDetail.interviewProcess.process[i].jdDetailsType = 0;
        vueObj.jobDetail.interviewProcess.process[i].showJDToPanel = false;
        vueObj.jobDetail.interviewProcess.process[i].configID = null;
        vueObj.fillAssessment(i, "");
      } else {
        vueObj.fillF2f(i);
        vueObj.jobDetail.interviewProcess.process[i].jdDetailsType = 0;
        vueObj.jobDetail.interviewProcess.process[i].showJDToPanel = false;
        delete vueObj.jobDetail.interviewProcess.process[i].testID;
        delete vueObj.jobDetail.interviewProcess.process[i].randomizeTest;
      }
    }
    vueObj.closeIP();
    let process = vueObj.jobDetail.interviewProcess.process[1];
    if (process.type === "assesment") {
      vueObj.jobDetail.vendorConfig.scheduleInterview = false;
      vueObj.jobDetail.vendorConfig.useInternalPanelist = false;
      vueObj.jobDetail.vendorConfig.useExternalPanelist = false;
      vueObj.jobDetail.vendorConfig.sendFeedbackRemainder = false;
    } else {
      vueObj.jobDetail.vendorConfig.scheduleAssesment = false;
    }
  }
  if (
    vueObj.checkIPSelected &&
    vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex].type ===
      "assesment"
  ) {
    handleassessmentChecks(vueObj);
  }
};
const handleassessmentChecks = (vueObj) => {
  for (let i in vueObj.jobDetail.interviewProcess.process[
    vueObj.selectedIPIndex
  ].selevaluator) {
    vueObj.selectedEvaluators.push(
      vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
        .selevaluator[i]
    );
  }
  vueObj.selectedTestIds.clear();
  vueObj.jobDetail.interviewProcess.process.forEach((process) => {
    if (vueObj.canAddTests(process)) {
      vueObj.addTests(process.selectedtests);
    }
  });
  vueObj.checkAutoTest();
};
const canAddTests = (vueObj, process) => {
  return (
    vueObj.checkValidRound(process.id) &&
    process.id !== vueObj.selectedIPIndex &&
    process.type === "assesment"
  );
};
const locationFunction = (vueObj) => {
  vueObj.loc = true;
  vueObj.$forceUpdate();
};
const toggleDocs = (vueObj) => {
  if (vueObj.jobDetail.documents) {
    vueObj.showDocs = !vueObj.showDocs;
  }
  if (vueObj.showDocs) {
    // Use setTimeout to wait for the DOM to update after toggling the 'showDocs'
    setTimeout(() => {
      const dropdownRef = vueObj.$refs.docsTypes;
      // Scroll the dropdown into view
      dropdownRef.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }, 100);
  }
  vueObj.searchdoc = "";
};
const openVendorModal = (vueObj) => {
  vueObj.searchVen = "";
  vueObj.vendors = [];
  vueObj.venPage = 0;
  vueObj.getVendors();
  vueObj.showVendors = !vueObj.showVendors;
  vueObj.showSpinner = true;
};

const clearfilter = (vueObj, objModal) => {
  vueObj.currentPage = 1;
  objModal.testoption = null;
  if (vueObj.filtercount != 0) {
    vueObj.openConfigModal();
  }
  vueObj.filtercount = 0;
};

const convertTime = (time, type) => {
  const dateStr = new Date(time);

  const givenDate = new Date(dateStr);

  const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
  const targetOffset = -5.5 * 60 * 60 * 1000; // Target offset in milliseconds

  const offsetDifference =
    type === "utc" ? targetOffset - istOffset : targetOffset + istOffset;

  const targetDate = new Date(givenDate.getTime() + offsetDifference);

  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, "0");
  const day = String(targetDate.getDate()).padStart(2, "0");
  const hours = String(targetDate.getHours()).padStart(2, "0");
  const minutes = String(targetDate.getMinutes()).padStart(2, "0");
  const seconds = String(targetDate.getSeconds()).padStart(2, "0");

  const formattedTargetTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;

  return formattedTargetTime;
};

module.exports = {
  addTestsFromModal,
  closeConfigModal,
  tagValidatorSkills,
  tagValidatorLoc,
  checkSalary,
  checkDecimal,
  setOnClickListeners,
  getExperience,
  checkAllBasic,
  checkAllData,
  checkIPRound,
  checkSaveAndApprove,
  invalidCharactersPassing,
  checkErrorBasic,
  checkJDType,
  betweenCheck,
  invalidCharactersCheck,
  checkPanelRequired,
  deleteTest,
  onEvalScroll,
  checkConfig,
  goBack,
  validateDates,
  openViewJdModal,
  onVenScroll,
  selectDosAndDonts,
  openAddConfigModal,
  removeRecruiter,
  removePanelist,
  saveRecruiters,
  savePanelists,
  fillConfigData,
  viewConfig,
  openFolderModal,
  closeFolder,
  saveConfig,
  gotopgnum,
  saveEvaluators,
  fillAssessment,
  fillF2f,
  selectRound,
  canAddTests,
  locationFunction,
  toggleDocs,
  closeModal,
  openVendorModal,
  filterDocs,
  clearfilter,
  convertTime,
};
